export const PARTNERSHIP_TYPE_LABELS = {
  academic: 'Académique',
  research: 'Recherche',
  industry: 'Industrie',
  other: 'Autre',
};

export function getPartnershipTypeLabel(type) {
  return PARTNERSHIP_TYPE_LABELS[type] || type;
}

export function formatDateFr(d) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('fr-FR', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}
